const PROTOCOL_RELATIVE_PREFIX = '//';
const DEFAULT_PROTOCOL = 'https:';

export const getUrlHost = (url: string): string => {
  const absolute = url.startsWith(PROTOCOL_RELATIVE_PREFIX)
    ? `${DEFAULT_PROTOCOL}${url}`
    : url;
  try {
    return new URL(absolute).host;
  } catch {
    return '';
  }
};
